export default __webpack_public_path__ + "contentweb/app/pages/Solutions/static/images/Progressive.71c38bd8.svg";